import gql from 'graphql-tag';

const SWITCH_EXTERNAL_ISSUE = gql`
    mutation switchExternalIssue($input: ExternalIssueSwitchInput) {
        switchExternalIssue (input: $input) {
            internalCode
        }
    }
`;

export default SWITCH_EXTERNAL_ISSUE;
